import React, { useEffect, useState } from 'react';
import { Box, TextField } from '@mui/material';

function Rodape({ itens }) {
  const [totals, setTotals] = useState({ totalPedido: 0, totalItens: 0 });

  useEffect(() => {
    const totalPedido = itens.reduce((acc, item) => acc + (item.total || 0), 0);
    const totalItens = itens.reduce((acc, item) => acc + (item.quantidade || 0), 0);

    setTotals({ totalPedido, totalItens });
  }, [itens]);

  return (
    <Box sx={{ marginTop: 2, borderTop: '1px solid #ddd', paddingTop: 2 }}>
      <TextField
        label="Total de Itens"
        value={totals.totalItens.toFixed(2)}
        InputProps={{ readOnly: true }}
        variant="outlined"
        sx={{ marginRight: 2 }}
      />
      <TextField
        label="Valor Total"
        value={totals.totalPedido.toFixed(2)}
        InputProps={{ readOnly: true }}
        variant="outlined"
      />
    </Box>
  );
}

export default Rodape;
